export const RuntimeEnvironment = {
  is_mobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
  is_chrome: /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
  is_safari: /apple/i.test(navigator.vendor),
  is_ios: (/iPhone|iPad|iPod/i.test(navigator.userAgent)),
  is_apple: (/apple|iPhone|iPad|iPod/i.test(navigator.userAgent)),
  is_android: (/(android)/i.test(navigator.userAgent)),
};